
const Logo = () => {
  return (
    <h2
      style={{
        color: "var(--primary-900)",
        fontWeight: 600,
      }}
    >
      ProAd.Live
    </h2>
  );
};

export default Logo;
